var exports = {
  "O": "NotificationDot.module__dot___MFduYz",
  "s": "NotificationDot.module__srOnly___MFduYz",
};

module.exports = exports;
